module.exports = __webpack_public_path__ + "img/logo.5cbf1f26.png";